<template>
  <PageSlot :isshowaiinputbox="false">
    <template #pageslot-contents>
      <div class="aichannel-pagecontainer">
        <img class="white-dimimg" src="/media/images/white-dim.png" alt="white-dim.png" />
        <img class="aichannel-bgimg" src="/media/images/aichannel-img.jpeg" alt="aichannel-img.jpeg" />

        <!-- 대화 화면 -->
        <div class="max960-container aichannel-container">
          <AiChat :aichanneltype="'aichannel'" :spaceid="spaceId" />
        </div>
      </div>
    </template>
  </PageSlot>
</template>
<script>
import PageSlot from '@/slot/PageSlot.vue';
import AiChat from '@/components/AiChat/AiChat.vue';
export default {
  components: {
    PageSlot,
    AiChat
  },
  computed: {
    spaceId() {
      return this.$cookies.get('spaceId');
    }
  }
};
</script>
<style scoped src="@/assets/css/aichannel/aichannel.css"></style>
